export default "__VITE_ASSET__CflWEB_W__"